import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import '../styles/header.css';
import '../styles/course-detail.css';

// Move courses data outside the component
const COURSES_DATA = {
  'apex-mastery': {
    id: 'apex-mastery',
    title: 'Apex Basics to Advanced',
    description: 'Master Apex programming from fundamentals to advanced concepts with real-world projects.',
    price: '$199',
    instructor: 'Salesforce Certified Architect',
    modules: [
      { title: 'Introduction to Apex', duration: '45 min', videoUrl: '#' },
      { title: 'Variables and Data Types', duration: '60 min', videoUrl: '#' },
      { title: 'SOQL and SOSL Queries', duration: '75 min', videoUrl: '#' },
      { title: 'Triggers and Best Practices', duration: '90 min', videoUrl: '#' },
      { title: 'Advanced Apex Patterns', duration: '120 min', videoUrl: '#' }
    ],
    resources: [
      'Apex Cheat Sheet.pdf',
      'Sample Projects.zip',
      'Interview Questions.docx'
    ],
    exercises: [
      'Create a trigger for Account object',
      'Write a batch Apex class',
      'Implement a REST API endpoint'
    ]
  },
  'lwc-interview': {
    id: 'lwc-interview',
    title: 'LWC Interview Preparation Kit',
    description: 'Ace your Lightning Web Components interviews with our comprehensive preparation course.',
    price: '$149',
    instructor: 'Senior LWC Developer',
    modules: [
      { title: 'LWC Fundamentals', duration: '50 min', videoUrl: '#' },
      { title: 'Component Communication', duration: '65 min', videoUrl: '#' },
      { title: 'Working with Apex', duration: '70 min', videoUrl: '#' },
      { title: 'Lightning Data Service', duration: '55 min', videoUrl: '#' },
      { title: 'Mock Interview Session', duration: '90 min', videoUrl: '#' }
    ],
    resources: [
      'LWC Best Practices.pdf',
      'Common Interview Questions.docx',
      'Sample Components.zip'
    ],
    exercises: [
      'Create a reusable data table component',
      'Implement parent-child communication',
      'Build a form with validation'
    ]
  },
  'apex-interview': {
    id: 'apex-interview',
    title: 'Apex Interview Preparation Kit',
    description: 'Prepare for Salesforce developer interviews with focused Apex training and practice.',
    price: '$149',
    instructor: 'Salesforce Technical Lead',
    modules: [
      { title: 'Apex Basics Review', duration: '40 min', videoUrl: '#' },
      { title: 'Trigger Frameworks', duration: '80 min', videoUrl: '#' },
      { title: 'Testing Best Practices', duration: '60 min', videoUrl: '#' },
      { title: 'Governor Limits', duration: '70 min', videoUrl: '#' },
      { title: 'Scenario-Based Questions', duration: '90 min', videoUrl: '#' }
    ],
    resources: [
      'Apex Design Patterns.pdf',
      'Interview Scenarios.docx',
      'Code Samples.zip'
    ],
    exercises: [
      'Write a test class with 100% coverage',
      'Optimize a trigger to avoid limits',
      'Implement a trigger handler pattern'
    ]
  }
};

const CourseDetail = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  
  // Get the course data
  const course = COURSES_DATA[courseId];

  // Handle case where course doesn't exist
  if (!course) {
    return (
      <div className="course-detail-page">
        {/* <Header /> */}
        <div className="course-not-found">
          <h2>Course not found</h2>
          <button onClick={() => navigate('/')} className="back-button">
            Back to Courses
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="course-detail-page">
      {/* <Header /> */}
      
      <div className="course-header">
        <h1>{course.title}</h1>
        <p className="course-description">{course.description}</p>
        <p className="course-instructor">Instructor: {course.instructor}</p>
        <p className="course-price">{course.price}</p>
        <button onClick={() => navigate('/enroll')} className="enroll-button">
            {course.isSession ? 'Book This Session' : 'Buy This Course'}
        </button>
            
        
      </div>

      <div className="course-content">
        <section className="course-modules">
          <h2>Course Modules</h2>
          <ul>
            {course.modules.map((module, index) => (
              <li key={index}>
                <a href={module.videoUrl}>
                  {module.title} 
                  <span className="module-duration">{module.duration}</span>
                </a>
                <div className="module-progress">
                  <div className="module-progress-bar" style={{ width: '0%' }}></div>
                </div>
              </li>
            ))}
          </ul>
        </section>

        <section className="course-resources">
          <h2>Downloadable Resources</h2>
          <ul>
            {course.resources.map((resource, index) => (
              <li key={index}>
                <a href="#">{resource}</a>
              </li>
            ))}
          </ul>
        </section>

        <section className="course-exercises">
          <h2>Hands-on Exercises</h2>
          <ol>
            {course.exercises.map((exercise, index) => (
              <li key={index}>{exercise}</li>
            ))}
          </ol>
        </section>
      </div>

      <div className="course-cta">
        <button className="enroll-button">Enroll in This Course</button>
        <a href="/" className="back-to-courses">Back to All Courses</a>
      </div>

      <footer className="page-footer">
        <p>© {new Date().getFullYear()} CodeXLNC Mastery Courses. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default CourseDetail;